// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_pg-0";